import { attributesConditionsMatch } from 'shared-helpers/customAttributes';

import type { Locales, User, UserCustomAttribute } from 'shared-types';

interface Params {
  customAttributeValues: User['customAttributes'];
  language: Locales;
  optionGroups: UserCustomAttribute['optionGroups'];
}

const getApplicableUserCustomAttributeOptions = ({
  customAttributeValues = {},
  language,
  optionGroups
}: Params) => {
  if (!optionGroups?.length) return [];

  let applicableOptions: { label: string; value: string }[] = [];

  for (const optionGroup of optionGroups) {
    const conditionsMatch = optionGroup.conditions?.length
      ? attributesConditionsMatch({
          conditions: optionGroup.conditions,
          customAttributeValues: customAttributeValues
        })
      : true;

    if (conditionsMatch) {
      applicableOptions = optionGroup.options.map((option) => ({
        label: option.labelTranslations?.[language] || option.label,
        value: option.key,
        ...(optionGroup.enableKeys ? { helpText: option.key } : {})
      }));

      if (optionGroup.sort === 'alphabetical') {
        applicableOptions.sort((a, b) =>
          a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1
        );
      }

      break;
    }
  }

  return applicableOptions;
};

export default getApplicableUserCustomAttributeOptions;
